import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'gdp-activation-link-main',
  templateUrl: './activation-link-main.component.html',
  styleUrls: ['./activation-link-main.component.scss']
})
export class ActivationLinkMainComponent {
  // TABS
  // Commented tabs for legacy pricing, to be removed once confirmed as obsolete
  public TABS: string[] = [
    'unlimited-users-professionale',
    // 'essential-professional-prime',
    // 'digital-phone-allinclusive',
  ];
  public TAB_ICONS = {
    //'essential-professional-prime': ['icon-small-telephone'],
    //'digital-phone-allinclusive': ['icon-small-handset'],
    'unlimited-users-professionale': ['icon-big-user-add', 'icon-small-handset'],
  }
  public currentTab: string = this.router.url
    .split('/')
    .slice(-1)[0] || this.TABS[0];


  constructor(private router: Router) { }


  public switchTab(tabId: string): void {
    this.router.navigate([`/dashboard/sales/activation-link/${tabId}`]);
    this.currentTab = tabId;
  }

}
